import { storageSession } from '@pureadmin/utils'
import {
  registerMicroApps,
  initGlobalState,
  MicroAppStateActions
} from 'qiankun'
import { DataInfo, getToken, sessionKey } from './auth'
import { reactive } from 'vue'
import { useUserStore } from '@/store/modules/user'
import Watermark from '@/utils/watermark.js'
import { EventSourcePolyfill } from 'event-source-polyfill'
import { baseUrl } from '@/utils/index'

// 初始化 state
export const initState = () => {
  const state = reactive({
    currentOrg: {},
    noticeInfo: ''
  })
  const actions: MicroAppStateActions = initGlobalState(state)

  return actions
}
export function registerMicroAppList() {
  const userStore = useUserStore()
  const eventSource = new EventSourcePolyfill(
    `${baseUrl}/message/v1.0.0/sse/_createConnect?userId=${userStore.userId}`,
    {
      headers: {
        Authorization: getToken()
      },
      heartbeatTimeout: 1000 * 60 * 30
    }
  )
  eventSource.onmessage = (e) => {
    initState().setGlobalState({
      noticeInfo: e.data
    })
  }
  const userInfo = storageSession().getItem<DataInfo>(sessionKey)
  const map = new Map()
  // 注册应用去重处理
  userInfo.apps.map((item) => {
    if (!map.has(item.appName)) {
      map.set(item.appName, item)
    }
  })

  const appList = [...map.values()].map((item) => {
    return {
      name: item.appName,
      entry:
        process.env.NODE_ENV === 'development'
          ? //? 'http://localhost:9527/hops/'
            `${item.protocol}://${item.appHost}:${item.appPort}${item.contextPath}`
          : // '/system/'
            item.contextPath,
      container: '#childDemo',
      activeRule: `/${item.appName}`
    }
  })
  // qiankun 注册子应用
  registerMicroApps(appList, {
    beforeLoad: [
      async (app) => {
        console.log('before load app.name === > ', app.name)
      }
    ],
    afterMount: [
      async () => {
        const userStore = useUserStore()
        const currentOrg = userStore.currentOrg
        const username =
          storageSession().getItem<DataInfo>(sessionKey)?.userName
        const account = storageSession().getItem('account')
        Watermark.set(`${username} ${account} ${currentOrg.orgName}`)
        initState().setGlobalState({
          currentOrg: {
            orgId: currentOrg.orgId,
            orgName: currentOrg.orgName
          }
        })
      }
    ]
  })
}
